var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBgBottomPinkGradient(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1032,
    height: 336,
    viewBox: "0 0 1032 336",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.7,
    filter: "url(#filter0_f_17229_70790)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M545.654 71.3915C651.17 60.8006 759.261 11.3111 851.583 63.509C965.513 127.924 1086.14 239.299 1073.02 369.558C1060.04 498.351 899.256 542.132 795.568 619.57C715.507 679.364 645.363 757.063 545.654 763.414C440.387 770.119 344.958 718.425 261.751 653.572C163.336 576.864 32.4666 494.118 40.339 369.558C48.1523 245.933 188.864 182.254 295.517 119.322C371.533 74.4685 457.841 80.2054 545.654 71.3915Z",
    fill: "url(#paint0_linear_17229_70790)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_17229_70790",
    x: 0,
    y: 0,
    width: 1114,
    height: 804,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 20,
    result: "effect1_foregroundBlur_17229_70790"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_17229_70790",
    x1: 1109.84,
    y1: -266.263,
    x2: 679.976,
    y2: 938.487,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E00B7E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.537161,
    stopColor: "#E00B7E",
    stopOpacity: 0.337552
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82456,
    stopColor: "#E00B7E",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBgBottomPinkGradient);
export default __webpack_public_path__ + "static/media/bg-bottom-pink-gradient.8381307c69bbdf050973102cb54fc48c.svg";
export { ForwardRef as ReactComponent };